import { RateSheetGenerationIndexResponse } from 'RtModels';
import { DataGridColumn } from 'RtUi/components/data/DataGrid/types';
import { DefaultDataGridColumn } from 'RtUi/components/data/DataGrid/columns/DefaultDataGridColumn';
import { TimeStampDataGridColumn } from 'RtUi/components/data/DataGrid/columns/TimeStampDataGridColumn';
import { LabelDataGridColumn } from 'RtUi/components/data/DataGrid/columns/LabelDataGridColumn';

export const getRateSheetGenerationColumns = (): Array<
	DataGridColumn<RateSheetGenerationIndexResponse>
> => [
	LabelDataGridColumn({
		accessorKey: 'rateSheetGenerationUuid',
		header: 'Id',
		isHidden: true
	}),
	DefaultDataGridColumn({
		accessorKey: 'rateSheetGeneratorId',
		header: 'Generator Id',
		isHidden: true
	}),
	DefaultDataGridColumn({
		accessorKey: 'rateSheetGeneratorLabel',
		header: 'Generator'
	}),
	DefaultDataGridColumn({
		accessorKey: 'notes',
		header: 'Notes'
	}),
	DefaultDataGridColumn({
		accessorKey: 'requestedByUser',
		header: 'Requested By'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'requestedTs',
		header: 'Requested'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'startedTs',
		header: 'Started'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'completedTs',
		header: 'Completed'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'createdTs',
		header: 'Created'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'updatedTs',
		header: 'Updated'
	})
];
